export function matchesPageSearch(page, query) {
  if (!query) return true

  const normalized = query.trim().toLowerCase()
  if (!normalized) return true

  const fields = [
    page.title_en,
    page.title_ar,
    page.slug,
    page.excerpt_en,
    page.excerpt_ar,
    page.meta_title_en,
    page.meta_title_ar,
  ]

  return fields.some((value) => value && String(value).toLowerCase().includes(normalized))
}

function flattenMenuPageRefs(menus, depth = 0, refs = []) {
  if (!Array.isArray(menus)) return refs

  const sorted = [...menus].sort(
    (a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0) || a.id - b.id,
  )

  sorted.forEach((menu) => {
    if (menu.page_id || menu.slug) {
      refs.push({
        pageId: menu.page_id ?? null,
        slug: menu.slug ?? null,
        depth,
      })
    }

    if (menu.children?.length) {
      flattenMenuPageRefs(menu.children, depth + 1, refs)
    }
  })

  return refs
}

export function orderPagesByMenu(pages, menuTree) {
  if (!Array.isArray(pages) || pages.length === 0) return []

  const pageById = new Map(pages.map((page) => [page.id, page]))
  const pageBySlug = new Map(pages.map((page) => [page.slug, page]))
  const used = new Set()
  const ordered = []

  flattenMenuPageRefs(menuTree).forEach((ref) => {
    const page =
      (ref.pageId ? pageById.get(ref.pageId) : null) ||
      (ref.slug ? pageBySlug.get(ref.slug) : null)

    if (!page || used.has(page.id)) return

    used.add(page.id)
    ordered.push({
      ...page,
      depth: ref.depth,
      displayOrder: ordered.length + 1,
      inMenu: true,
    })
  })

  pages
    .filter((page) => !used.has(page.id))
    .sort(
      (a, b) =>
        (a.sort_order ?? 0) - (b.sort_order ?? 0) ||
        a.title_en.localeCompare(b.title_en),
    )
    .forEach((page) => {
      ordered.push({
        ...page,
        depth: 0,
        displayOrder: ordered.length + 1,
        inMenu: false,
      })
    })

  return ordered
}
